import { PERCENTAGE_MAX } from "@/constants/percentage.constants";
import { formatScoreValue } from "@/helpers/number/number.helpers";
import { UseEvaluationPercentageArgs } from "./useEvaluationPercentage.decl";

export function useEvaluationPercentage({
  points,
  maximumPoints,
}: UseEvaluationPercentageArgs) {
  const percentage = formatScoreValue(
    (points / (maximumPoints || 1)) * PERCENTAGE_MAX
  );

  return {
    percentage,
  };
}
